import React from "react";
import styles from "./StockPrices.module.css";
import { FaCaretUp, FaCaretDown } from "react-icons/fa"; // 가격 변동 아이콘

const stockData = [
  {
    name: "STARNEX",
    price: 7000,
    change: 0,
    parValue: 100,
    marketCap: "10B",
    transferable: true,
  },
  {
    name: "DASSTECH",
    price: 3900,
    change: 0,
    parValue: 100,
    marketCap: "5B",
    transferable: true,
  },
  {
    name: "JB BIOTECH",
    price: 3800,
    change: 0,
    parValue: 500,
    marketCap: "8B",
    transferable: true,
  },
  {
    name: "BIO PHARMA",
    price: 3800,
    change: 0,
    parValue: 500,
    marketCap: "12B",
    transferable: true,
  },
];

const StockPrices = () => {
  return (
    <section className={styles.stockPrices}>
      <h2 className={styles.title}>Stock Prices</h2>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Stock Name</th>
              <th>Base Price</th>
              <th>Price Range</th>
              <th>Par Value</th>
              <th>Market Cap</th>
              <th>Transferable</th>
            </tr>
          </thead>
          <tbody>
            {stockData.map((stock, index) => (
              <tr key={index}>
                <td className={styles.stockName}>{stock.name}</td>
                <td
                  className={`${styles.price} ${
                    stock.change > 0
                      ? styles.up
                      : stock.change < 0
                      ? styles.down
                      : ""
                  }`}
                >
                  ₩{stock.price.toLocaleString()}
                </td>
                <td className={styles.change}>
                  {stock.change !== 0 ? (
                    stock.change > 0 ? (
                      <span className={styles.up}>
                        <FaCaretUp /> {stock.change}
                      </span>
                    ) : (
                      <span className={styles.down}>
                        <FaCaretDown /> {stock.change}
                      </span>
                    )
                  ) : (
                    "-"
                  )}
                </td>
                <td>₩{stock.parValue.toLocaleString()}</td>
                <td>{stock.marketCap}</td>
                <td>
                  <span
                    className={
                      stock.transferable
                        ? styles.transferable
                        : styles.notTransferable
                    }
                  >
                    {stock.transferable ? "가능" : "불가"}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default StockPrices;
